export const DEFAULT_TIMEZONE = 'Europe/Warsaw';

export const FALLBACK_TIMEZONE = 'UTC';
